(() => {
  if (!customElements.get("details-disclosure")) {
    class e extends HTMLElement {
      #e;
      #t;
      #s;
      #i=!1;
      #o=!1;
      #n=null;
      constructor() {
        super(), this.#e = this.querySelector("details"), this.#t = this.querySelector("summary"), 
        this.#s = this.querySelector("details > *:not(summary):not([data-close-parent]):not([data-hover-close])"), 
        this.#e && this.#t ? this.#o = this.#e.hasAttribute("open") : console.error("[DetailsDisclosure] Component must have a <details> and <summary> element.");
      }
      connectedCallback() {
        this.hasAttribute("data-hover") && (this.#t.addEventListener("mouseenter", this.#a), 
        this.addEventListener("mouseenter", this.#r), this.addEventListener("mouseleave", this.#l)), 
        this.#t.addEventListener("click", this.#h), this.addEventListener("click", this.#m), 
        this.#u();
      }
      disconnectedCallback() {
        this.#n && (clearTimeout(this.#n), this.#n = null), this.hasAttribute("data-hover") && (this.#t.removeEventListener("mouseenter", this.#a), 
        this.removeEventListener("mouseenter", this.#r), this.removeEventListener("mouseleave", this.#l)), 
        this.#t.removeEventListener("click", this.#h), this.removeEventListener("click", this.#m), 
        this.#c();
      }
      get isOpen() {
        return this.#e?.hasAttribute("open") || !1;
      }
      #h=e => {
        e.preventDefault(), this.isOpen ? this.close() : this.open();
      };
      #a=() => {
        this.#n && (clearTimeout(this.#n), this.#n = null), this.isOpen || this.open();
      };
      #r=() => {
        this.#n && (clearTimeout(this.#n), this.#n = null);
      };
      #l=() => {
        this.#n && clearTimeout(this.#n), this.#n = setTimeout(() => {
          this.isOpen && this.close();
        }, 150);
      };
      #u() {
        this.querySelectorAll("[data-hover-close]").forEach(e => {
          e.addEventListener("mouseenter", this.#d);
        });
      }
      #c() {
        this.querySelectorAll("[data-hover-close]").forEach(e => {
          e.removeEventListener("mouseenter", this.#d);
        });
      }
      #d=e => {
        this.#v(e);
      };
      #m=e => {
        const t = e.target.closest("[data-close]"), s = e.target.closest("[data-close-parent]");
        t ? (e.preventDefault(), this.close()) : s && this.#v(e);
      };
      #v=e => {
        const t = e.target.closest("details");
        e.stopPropagation(), e.preventDefault(), t === this.#e && (null === this.#e.closest("details") || this.hasAttribute("data-scroll-lock") || this.hasAttribute("data-menu") ? this.close() : this.close(!1));
      };
      async open() {
        if (!this.isOpen) {
          if (this.#n && (clearTimeout(this.#n), this.#n = null), this.#i && this.hasAttribute("data-hover")) this.#i = !1; else if (this.#i) return;
          this.#i = !0, this.#e.setAttribute("open", ""), this.#t.setAttribute("aria-expanded", "true"), 
          this.#p(!0), this.querySelectorAll("vanilla-slider [data-slider]").forEach(e => {
            e.scrollTo({
              left: 1,
              behavior: "instant"
            });
          }), await this.#y(), this.#i = !1, this.#o = !1;
        }
      }
      async close(e = !0) {
        if (!this.isOpen || this.#i) return;
        this.#i = !0, this.#t.setAttribute("aria-expanded", "false");
        const t = await this.#y(!0);
        if (this.#e.removeAttribute("open"), e && this.#p(!1), t.length > 0) for (const e of t) {
          const t = e.effect.target;
          t.style.animation = "none", t.offsetHeight, t.style.animation = "";
        }
        this.#i = !1;
      }
      async #y(e = !1) {
        const t = [ this.#t, this.#s ].filter(Boolean);
        await new Promise(e => requestAnimationFrame(e));
        const s = t.flatMap(e => e.getAnimations());
        if (0 === s.length) return [];
        for (const t of s) e ? t.reverse() : (t.currentTime = 0, t.play());
        return await Promise.all(s.map(e => e.finished)), s;
      }
      #p(e) {
        const t = e && !this.#o;
        this.hasAttribute("data-scroll-lock") && document.body.classList.toggle("overflow-hidden", t), 
        this.hasAttribute("data-menu") && document.body.classList.toggle("is-menu-open", t);
      }
    }
    customElements.define("details-disclosure", e);
  }
})();